function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import { AppContext } from 'context';
import history from 'helpers/history';
import { useAction } from 'hooks';
import App from 'modules/App';
import * as constants from '../../constants';
import messages from '../../messages';
import styles from './Create.pcss';
const Create = ({ countryCode, isSetup = false })=>{
    const intl = useIntl();
    useStyles(styles);
    const { getUrl } = useContext(AppContext);
    const setFormValues = useAction(App.actions.setFormValues, constants.CREATE_FORM);
    const onCreate = ()=>{
        if (countryCode) {
            setFormValues({
                countryCode
            });
        }
        const url = getUrl(isSetup ? 'organization-add' : 'organization-create');
        history.push(url);
    };
    const buttonLabel = intl.formatMessage(messages.buttons.createOrganization);
    return /*#__PURE__*/ _jsxs("div", {
        className: "d-flex align-items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mr-5",
                children: /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: styles.createButton,
                    onClick: onCreate,
                    "aria-label": buttonLabel
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text--base text--bold text-lh--14",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.createOrganizationLead))
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text--small text-lh--14",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.createOrganizationSubLead))
                    })
                ]
            })
        ]
    });
};
export default /*#__PURE__*/ memo(Create);
